import React from 'react'
import { useRealtimeConnection } from '@/hooks/useRealtimeConnection'

export function ConnectionStatus() {
  const { status } = useRealtimeConnection()
  if (status === 'connected') return null
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-800 rounded-lg shadow-lg border border-yellow-200">
        {status === 'reconnecting' ? (
          <>
            <span className="h-3 w-3 rounded-full bg-yellow-600 animate-pulse" />
            <span className="text-sm">Reconnecting...</span>
          </>
        ) : (
          <>
            <span className="h-3 w-3 rounded-full bg-gray-500" />
            <span className="text-sm">Disconnected</span>
          </>
        )}
      </div>
    </div>
  )
}


